export const getOrderColumns = (
  t,
  settings,
  permissions,
  radioValue = {},
  radioValue2 = {},
) => {
  return [
    {
      title: t("Country"),
      condition: settings.is_gcc,
      field: "country",
    },
    {
      title: t("For branch"),
      condition: settings.is_branch_based_ordering,
      field: "for_branch",
    },

    {
      title: t("Type"),
      condition: !settings.enable_table_qr,
      field: "type",
    },
    {
      title: t("Id"),
      condition: true,
      field: "number",
    },
    {
      title: t("Sequential Order Number"),
      condition: settings.enable_order_numbering,
      field: "order-sequence-number",
    },
    {
      title: settings.enable_car_qr ? t("Parking #") : t("Table #"),
      condition: settings.enable_car_qr || settings.enable_table_qr,
      field: "table_parking",
    },
    {
      title: t("Ocims Status"),
      condition: settings.enable_ocims && radioValue2 !== "new",
      field: "ocims",
    },
    {
      title: t("Customer"),
      condition:
        !settings.enable_table_qr || settings.require_dine_in_contact_info,
      field: "customer",
    },
    {
      title: t("Area"),
      condition: !settings.enable_table_qr,
      field: "area",
    },
    {
      title: t("Province"),
      condition: !settings.enable_table_qr,
      field: "province",
    },
    {
      title: t("Due Status"),
      condition:
        settings.due_soon_toggle &&
        radioValue === "today" &&
        radioValue2 !== "new",
      field: "due_status",
    },
    {
      title: t("Expected Date"),
      condition: !settings.enable_table_qr,
      field: "expected_date",
    },
    {
      title: t("Expected Time"),
      condition: !settings.enable_table_qr,
      field: "expected_time",
    },
    {
      title: t("Received"),
      condition: true,
      field: "received",
    },
    {
      title: t("Payment Type"),
      condition: true,
      field: "payment_type",
    },
    {
      title: t("Payment Status"),
      condition: true,
      field: "payment_status",
    },
    {
      title: t("Payment Reference"),
      condition: true,
      field: "payment_reference",
    },
    {
      title: t("Channel"),
      condition: settings.enable_pos,
      field: "channel",
    },
    {
      title: t("Order Placed By"),
      condition: true,
      field: "order_placed_by",
    },
    {
      title: t("Notes"),
      condition: true,
      field: "notes",
    },
    {
      title: t("Source"),
      condition: true,
      field: "source",
    },

    {
      title: settings.enable_grubtech
        ? t("Received on Grubtech")
        : settings.enable_urban_piper
          ? t("Received on Urban Piper")
          : t("Received on Deliverect"),
      condition:
        permissions.can_view_integrations &&
        (settings.enable_deliverect ||
          settings.enable_grubtech ||
          settings.enable_urban_piper) &&
        radioValue2 !== "new",
      field: "integration",
    },
    {
      title: t("Received on Foodics"),
      condition:
        permissions.can_view_integrations &&
        settings.enable_foodics &&
        radioValue2 !== "new",
      field: "foodics",
    },
    {
      title: t("Received on Matix"),
      condition:
        permissions.can_view_integrations &&
        settings.enable_matix &&
        radioValue2 !== "new",
      field: "matix",
    },
    {
      title: t("Source"),
      condition: settings.enable_pos,
      field: "source",
    },
  ];
};
